<script>
  import en from './en';
  import ru from './ru';
  import id from './id';

  const fallback_lang = 'en';
  export default {
    functional: true,
    props: {
      lang: {
        type: String,
        default: fallback_lang
      }
    },
    render(h, context) {
      const lang = context.props.lang;
      const lang_list = {
        ru: ru,
        en: en,
        id: id
      };
      const current_lang = lang_list[lang] || lang_list[fallback_lang];
      return h(current_lang, context.data, context.children);
    }
  };
</script>
